import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {DialogService} from '../../../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../../../services/snackbar/snackbar.service';
import {StaticPageService} from '../../../../../../services/cms/static-page.service';
import {AvailableDomainService} from '../../../../../../services/cms/available-domain.service';
import {DialogParams} from '../../../../../../interfaces/dialog/dialog-params';
import {Dialog} from '../../../../../../interfaces/dialog/dialog';
import {StaticPage} from '../../../../../../models/cms/static-page';
import {AvailableDomain} from '../../../../../../models/cms/available-domain';

@Component({
  selector: 'app-static-page-duplicate',
  imports: [
    ReactiveFormsModule,
  ],
  templateUrl: './static-page-duplicate.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './static-page-duplicate.component.scss'
})
export class StaticPageDuplicateComponent implements Dialog {

  staticPage!: StaticPage;
  availableDomains: AvailableDomain[] = [];
  submitting: boolean = false;

  form: FormGroup = new FormGroup({
    domainId: new FormControl<number | null>(null, [Validators.required]),
    slug: new FormControl<string | null>(null, [Validators.required]),
  });

  constructor(
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private staticPageService: StaticPageService,
    private availableDomainService: AvailableDomainService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    const staticPage: StaticPage = params.data.staticPage;

    this.staticPageService.findOneById(staticPage.id, {groups: 'htmlContent'}).subscribe((fullPage: StaticPage) => {
      this.staticPage = fullPage;
    });

    this.availableDomainService.findAll({sort: 'domain'}).subscribe((domains: AvailableDomain[]) => {
      this.availableDomains = domains;
    });

    this.form.patchValue({
      domainId: staticPage.domain?.id ?? null,
      slug: staticPage.slug,
    });
  }

  invalid(): boolean {
    return this.form.invalid;
  }

  submit(): void {
    this.submitting = true;

    this.staticPageService.create({
      name: this.staticPage.name,
      domainId: this.form.value.domainId,
      slug: this.form.value.slug,
      locale: this.staticPage.locale,
      htmlContent: this.staticPage.htmlContent,
      status: this.staticPage.status,
      scope: this.staticPage.scope,
      publishedAt: this.staticPage.publishedAt,
      pageTypeId: this.staticPage.pageType?.id ?? null,
      productId: this.staticPage.product?.id ?? null,
    }).subscribe({
      next: () => {
        this.dialog.closeDialog();
        this.snackbar.success('Page duplicated successfully.');
        this.submitting = false;
      },
      error: () => {
        this.submitting = false;
      }
    });
  }
}
